<div class="sidenav">
  <h4>About Us</h4>
  <a href="/about">What it's all about</a>
  <mat-divider></mat-divider>
  <a href="/partners">Friends and Partners</a>
  <mat-divider></mat-divider>
  <a style="font-weight: bold; color: #753457;">Get in touch</a>
  <mat-divider></mat-divider>
  <a href="/apidocs">API docs</a>
</div>


<div class="navmobile">
  <h4>About Us</h4>
  <a href="/about">What it's all about</a>
  <mat-divider></mat-divider>
  <a href="/partners">Friends and Partners</a>
  <mat-divider></mat-divider>
  <a style="font-weight: bold; color: #753457;">Get in touch</a>
  <mat-divider></mat-divider>
  <a href="/apidocs">API docs</a>
</div>

<div class="center">
  <h2>Get in touch</h2>

  <div class="mapdiv">
    <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="15">
      <agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>

    </agm-map>
  </div><strong>
    <div class="circle">
      <div>
        Write to us at <br>
        <a href="mailto:info@lebtivity.com">info@lebtivity.com</a> <br>
        Give us a call on +961.3.376390 <br>
        or <br>
        simply pass by for a coffee or tea at <br> our offices: <br>
        <br>
        Caracas 1 Building, 5th floor - Bloc B,<br>
        Mirna Chalouhi Highway,<br>
        (Bauchrieh-Sin El Fil Highway)<br>
        Beirut, Lebanon<br>
        <br>
        <a href="https://www.facebook.com/Lebtivity"><i class="fa fa-facebook"></i></a>
        <a href="https://www.twitter.com/Lebtivity"><i class="fa fa-twitter"></i></a>
        <a href="mailto:info@lebtivity.com"><i class="fa fa-envelope"></i></a>
        <!-- <a [href]="emailstring" target="_top"><div>test</div></a> -->
      </div>
    </div>
  </strong>
</div>
